import React from 'react'
import styled from '@emotion/styled/macro'
import { gql } from '@apollo/client'
import mq from 'mediaQuery'
import { useQuery } from '@apollo/client'

export const IS_TESTNET = false

const BannerWrapper = styled('div')`
  display: flex;
  justify-content: center;
  font-size: 14px;
  padding: 3px;
  background: #c00909;
`

const BannerText = styled('div')`
  width: fit-content;
  color: #ffffff;
`

const BannerLink = styled('span')`
  cursor: pointer;
  text-decoration: underline;
`

const NETWORK_INFORMATION_QUERY = gql`
  query getNetworkInfo @client {
    accounts
    isReadOnly
    isSafeApp
    avatar
    network
    displayName
  }
`

function NetworkBanner() {
  const {
    data: { network }
  } = useQuery(NETWORK_INFORMATION_QUERY)

  return (
    IS_TESTNET && (
      <BannerWrapper>
        <BannerText>
          You are using the testnet version of Evmos Domains. The mainnet
          version can be found at{' '}
          <BannerLink
            onClick={() =>
              window.location.replace('https://app.evmos.domains/')
            }
          >
            https://app.evmos.domains
          </BannerLink>
          .
        </BannerText>
      </BannerWrapper>
    )
  )
}
export default NetworkBanner
